import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { Resolver } from 'react-hook-form';

import { PAYMENT_PROVIDERS_NAMES, PaymentProviderName } from 'domain/paySettings/helpers';
import { GlobalAccountFormConfig } from './types';
import OpenFinanceFields from './components/OpenFinanceForm';
import { openFinanceSchema } from './components/OpenFinanceForm/schema';
import { toPayload, fromAccountNumber, emptyDefaults } from './components/OpenFinanceForm/helpers';

export const globalAccountsConfig: Record<PaymentProviderName, GlobalAccountFormConfig> = {
  [PAYMENT_PROVIDERS_NAMES.airwallex]: {
    fields: [
      {
        type: 'text',
        name: 'name',
        label: {
          id: 'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.name',
          defaultMessage: 'Name',
        },
        required: true,
        autoFocus: true,
        defaultValue: '',
        editable: true,
      },
      {
        type: 'autocomplete',
        name: 'glBankAccountId',
        optionsKey: 'bankAccounts',
        label: {
          id: 'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.bankAccount',
          defaultMessage: 'GL Bank Account',
        },
        required: true,
        disableClearable: true,
        defaultValue: '',
        editable: true,
      },
    ],
    dataRequirements: ['bankAccounts'],
    schema: z.object({
      name: z.string().nonempty(),
      glBankAccountId: z.string().nonempty(),
    }),
  },
  [PAYMENT_PROVIDERS_NAMES.checkbook]: {
    fields: [
      {
        type: 'text',
        name: 'name',
        label: {
          id: 'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.name',
          defaultMessage: 'Name',
        },
        required: true,
        autoFocus: true,
        defaultValue: '',
        editable: true,
      },
      {
        type: 'autocomplete',
        name: 'glBankAccountId',
        optionsKey: 'bankAccounts',
        label: {
          id: 'configurations.company.paymentProviders.detailsModal.accountList.addModal.fields.bankAccount',
          defaultMessage: 'GL Bank Account',
        },
        required: true,
        disableClearable: true,
        defaultValue: '',
        editable: true,
      },
    ],
    dataRequirements: ['bankAccounts'],
    schema: z.object({
      name: z.string().nonempty(),
      glBankAccountId: z.string().nonempty(),
    }),
  },
  [PAYMENT_PROVIDERS_NAMES.openFinance]: {
    fields: [],
    schema: z.object({}),
    dataRequirements: ['bankAccounts', 'payingProviders'],
    FieldsComponent: OpenFinanceFields,
    dialogMaxWidth: 'sm',
    createResolver: () => zodResolver(openFinanceSchema) as unknown as Resolver<any>,
    getDefaultValues: (selectedAccount) => (selectedAccount ? fromAccountNumber(selectedAccount) : emptyDefaults()),
    toCreatePayload: toPayload,
    toUpdatePayload: (values, id) => ({ name: values.name, glBankAccountId: values.glBankAccountId, id }),
  },
  [PAYMENT_PROVIDERS_NAMES.leumi]: {
    fields: [],
    schema: z.object({}),
  },
  [PAYMENT_PROVIDERS_NAMES.raiffeisen]: {
    fields: [],
    schema: z.object({}),
  },
  [PAYMENT_PROVIDERS_NAMES.rbs]: {
    fields: [],
    schema: z.object({}),
  },
};
